import { render, staticRenderFns } from "./TodayEvent.vue?vue&type=template&id=2f36ba32&scoped=true"
import script from "./TodayEvent.vue?vue&type=script&lang=js"
export * from "./TodayEvent.vue?vue&type=script&lang=js"
import style0 from "./TodayEvent.vue?vue&type=style&index=0&id=2f36ba32&prod&lang=scss"
import style1 from "./TodayEvent.vue?vue&type=style&index=1&id=2f36ba32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f36ba32",
  null
  
)

export default component.exports